module.exports = __webpack_public_path__ + "73a393c88787b15d702855358f6d1f41.svg";